import axiosInstance from "./axiosInstance";
import {FormJob} from "../types/jobTypes";

export async function getJobsTableData (page: number, pageSize: number, includeRunningJobs:boolean = false) {

    const response = await axiosInstance.get('admin/dataTableJobs',
    {
        params: {
            page: page,
            pageSize: pageSize,
            includeRunningJobs: includeRunningJobs
        }
    })
    return response.data;
}

export async function restartJobFromTracks (jobData: FormJob) {
    const response = await axiosInstance.post('admin/job', jobData);
    return response.data;
}